import type { SVGProps } from "react";

export function IconDarkBlueThreeArrows(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.4">
        <path d="M20 4H28V12L24 8L20 4Z" fill="#23232C" />
        <path
          d="M4 28L24 8M28 4H20L28 12V4Z"
          stroke="#23232C"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path d="M20 19H28V27L24 23L20 19Z" fill="#23232C" />
        <path
          d="M19 28L24 23M28 19H20L28 27V19Z"
          stroke="#23232C"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path d="M5 4H13V12L9 8L5 4Z" fill="#23232C" />
        <path
          d="M4 13L9 8M13 4H5L13 12V4Z"
          stroke="#23232C"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
}
